<!-- eslint-disable vue/multi-word-component-names -->
<script>
  import AppTitleHeader from '@/components/app/TitleHeader.vue';
  import AppBox from '@/components/app/box.vue';
  import StationMixin from '@/Mixins/BaseInformation/StationMixin';
  import UserMixin from '@/Mixins/BaseInformation/UserMixin';
  import SharedHelper from '@/Helpers/Shared';
  export default {
    inject: ['load'],
    mixins: [StationMixin, UserMixin, SharedHelper],
    props: {
      userId: {
        type: Number,
        isRequired: true,
      },
    },
    components: { AppTitleHeader, AppBox },
    data() {
      return {
        editStationsSearchText: {
          all: '',
          user: '',
        },
        selectedStations: [],
      };
    },
    mounted() {
      this.getAllStations();
      this.getUserAllStations(this.userId);
    },
    methods: {
      addNewSelectedItems: function (item) {
        if (!this.doesItemExist(item?.id)) this.selectedStations = [...this.selectedStations, item];
      },
      addAllSelectedItems: function () {
        this.selectedStations = [...this.allStations];
      },
      deleteFromSelectedItems: function (id) {
        this.selectedStations = [...this.selectedStations]?.filter((item) => item?.id !== id);
      },
      deleteAllFromSelectedItems: function () {
        this.selectedStations = [];
      },
      doesItemExist: function (id) {
        return [...this.selectedStations].some((selectedItem) => selectedItem?.id === id);
      },
      onSubmit: function () {
        const body = {
          userId: this.userId,
          features: [...this.selectedStations]?.map(({ id }) => id),
        };
        this.setUserStations(body, () => this.$emit('closeModal'));
      },
    },
    computed: {
      filterdAllStations: function () {
        return [...this.allStations]?.filter(({ title }) =>
          title?.includes(this.editStationsSearchText.all),
        );
      },
      filterdSelectedStations: function () {
        return [...this.selectedStations]?.filter(({ title }) =>
          title?.includes(this.editStationsSearchText.user),
        );
      },
    },
    watch: {
      UserAllStations: function (value) {
        if (value?.length) this.selectedStations = [...this.selectedStations, ...value];
      },
    },
  };
</script>
<template>
  <v-card>
    <v-row no-gutters>
      <v-col cols="12" class="modal-header py-5">
        <v-row no-gutters>
          <v-spacer></v-spacer>
          <v-icon color="darkColor">mdi-pencil</v-icon>
          <span class="modal-title-text mr-2">ویرایش پایگاه ها</span>
          <v-spacer></v-spacer>
        </v-row>
      </v-col>
    </v-row>
    <v-card-text>
      <v-row class="mt-8">
        <app-title-header title="پایگاه ها" />
      </v-row>
      <v-row>
        <v-col cols="10">
          <v-text-field
            outlined
            rounded
            placeholder="جستجو..."
            append-icon="mdi-magnify"
            dense
            v-model="editStationsSearchText.all"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn
            @click="addAllSelectedItems()"
            rounded
            block
            color="lightColor"
            dark
            class="normal-letter-spacing"
          >
            افزودن همه لیست
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-n7">
        <v-col cols="12">
          <app-box outlined max-height="130px">
            <v-chip-group column>
              <v-chip
                class="all-chip"
                label
                v-for="item in filterdAllStations"
                :key="item.id"
                :disabled="doesItemExist(item?.id)"
              >
                {{ item.title }}
                <v-icon right @click="addNewSelectedItems(item)" color="darkColor">mdi-plus</v-icon>
              </v-chip>
            </v-chip-group>
          </app-box>
        </v-col>
      </v-row>
      <v-row>
        <app-title-header title="پایگاه های انتخابی" />
      </v-row>
      <v-row>
        <v-col cols="10">
          <v-text-field
            outlined
            rounded
            placeholder="جستجو..."
            append-icon="mdi-magnify"
            dense
            v-model="editStationsSearchText.user"
          ></v-text-field>
        </v-col>
        <v-col cols="2">
          <v-btn
            @click="deleteAllFromSelectedItems()"
            rounded
            block
            color="lightColor"
            dark
            class="normal-letter-spacing"
          >
            حذف همه لیست
          </v-btn>
        </v-col>
      </v-row>
      <v-row class="mt-n7">
        <v-col cols="12">
          <app-box outlined max-height="130px">
            <v-chip-group column>
              <v-chip
                label
                v-for="item in filterdSelectedStations"
                :key="item.id"
                color="darkColor"
                dark
              >
                {{ item.title }}
                <v-icon right @click="deleteFromSelectedItems(item?.id)">mdi-close</v-icon>
              </v-chip>
            </v-chip-group>
          </app-box>
        </v-col>
      </v-row>
    </v-card-text>
    <v-card-actions class="mt-2">
      <v-spacer></v-spacer>
      <v-btn color="darkColor" dark rounded @click="onSubmit" class="normal-letter-spacing px-12">
        ثبت
      </v-btn>
      <v-btn
        rounded
        color="darkColor"
        outlined
        @click="$emit('closeModal')"
        class="normal-letter-spacing px-10"
      >
        انصراف
      </v-btn>
    </v-card-actions>
  </v-card>
</template>
<style lang="scss">
  .modal-header {
    border-bottom: 2px solid var(--modal-border-color);
    border-bottom-right-radius: 12px !important;
    border-bottom-left-radius: 12px !important;
    .modal-title-text {
      color: var(--dark-color);
      font-weight: 500;
      font-size: 16px;
    }
  }
</style>
